// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "plane-2Pl9e";
var _3 = "plane_return-3xtwp";
export { _1 as "__esModule", _2 as "plane", _3 as "plane_return" }
export default { "__esModule": _1, "plane": _2, "plane_return": _3 }
